// src/Pages/AdminManagment/ViewAdmin.jsx
import React from "react";

function ViewAdmin({ data }) {
  const getRoleName = (role) => {
    if (role === '1') return 'Super Admin';
    if (role === '2') return 'Admin';
    if (role === '3') return 'User';
    return 'N/A';
  };

  const getStatusText = (status) => {
    if (status === 'active' || status === 'Active' || status === 1 || status === true) {
      return 'Active';
    }
    return 'Inactive';
  };

  const getStatusBadge = (status) => {
    const isActive = status === 'active' || status === 'Active' || status === 1 || status === true;
    return isActive ? 'bg-success' : 'bg-danger';
  };

  return (
    <div style={{ padding: '10px 0' }}>
      <div style={{ maxWidth: '100%' }}>
        {/* Avatar */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '20px' 
        }}>
          <div style={{ 
            width: '80px', 
            height: '80px', 
            borderRadius: '50%', 
            backgroundColor: '#0d6efd', 
            color: 'white', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            fontSize: '32px', 
            fontWeight: 'bold',
            margin: '0 auto',
            boxShadow: '0 4px 10px rgba(0,0,0,0.15)'
          }}>
            {data?.name?.charAt(0)?.toUpperCase() || 'A'}
          </div>
        </div>

        {/* Details Grid */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(2, 1fr)', 
          gap: '20px',
          padding: '0 10px'
        }}>
          {/* ADMIN NAME */}
          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '15px', 
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <span style={{ 
              fontSize: '12px', 
              color: '#6c757d', 
              fontWeight: '600',
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: '4px'
            }}>Admin Name</span>
            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#212529' }}>
              {data?.name || 'N/A'}
            </h5>
          </div>

          {/* EMAIL */}
          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '15px', 
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <span style={{ 
              fontSize: '12px', 
              color: '#6c757d', 
              fontWeight: '600',
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: '4px'
            }}>Email Address</span>
            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#212529' }}>
              {data?.email || 'N/A'}
            </h5>
          </div>

          {/* ROLE */}
          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '15px', 
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <span style={{ 
              fontSize: '12px', 
              color: '#6c757d', 
              fontWeight: '600',
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: '4px'
            }}>Role</span>
            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#212529' }}>
              <span style={{
                display: 'inline-block',
                padding: '4px 12px',
                borderRadius: '20px',
                fontSize: '14px',
                fontWeight: '600',
                color: 'white',
                backgroundColor: data?.role === '1' ? '#dc3545' : data?.role === '2' ? '#0d6efd' : '#6c757d'
              }}>
                {getRoleName(data?.role)}
              </span>
            </h5>
          </div>

          {/* STATUS */}
          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '15px', 
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <span style={{ 
              fontSize: '12px', 
              color: '#6c757d', 
              fontWeight: '600',
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: '4px'
            }}>Status</span>
            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#212529' }}>
              <span style={{
                display: 'inline-block',
                padding: '4px 12px',
                borderRadius: '20px',
                fontSize: '14px',
                fontWeight: '600',
                color: 'white',
                backgroundColor: getStatusBadge(data?.status) === 'bg-success' ? '#198754' : '#dc3545'
              }}>
                {getStatusText(data?.status)}
              </span>
            </h5>
          </div>

          {/* CREATED AT */}
          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '15px', 
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <span style={{ 
              fontSize: '12px', 
              color: '#6c757d', 
              fontWeight: '600',
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: '4px'
            }}>Created At</span>
            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#212529' }}>
              {data?.created_at 
                ? new Date(data.created_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })
                : 'N/A'
              }
            </h5>
          </div>

          {/* UPDATED AT */}
          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '15px', 
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <span style={{ 
              fontSize: '12px', 
              color: '#6c757d', 
              fontWeight: '600',
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: '4px'
            }}>Last Updated</span>
            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#212529' }}>
              {data?.updated_at 
                ? new Date(data.updated_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })
                : 'N/A'
              }
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewAdmin;